import React from "react"

import { SourceTab } from "./source-tab"
import { canNavigateToApp } from "./utils"

function TabSkeleton() {
  return (
    <div className="flex items-center px-3 py-2 w-full border border-transparent">
      <div className="flex justify-center items-center w-8 h-8 mr-3">
        <div
          className="w-full h-full animate-pulse"
          style={{
            background:
              "linear-gradient(180deg, var(--gray-200) 0%, var(--gray-50) 100%)",
            borderRadius: "4px"
          }}
        />
      </div>
      <div
        className="h-4 w-24 animate-pulse"
        style={{
          background:
            "linear-gradient(180deg, var(--gray-200) 0%, var(--gray-50) 100%)",
          borderRadius: "4px"
        }}
      />
    </div>
  )
}

export function PluginTabs({
  activeTab,
  setActiveTab,
  hasError,
  isLoading,
  plugins
}) {
  if (hasError) return null

  if (isLoading) {
    return (
      <>
        <TabSkeleton />
        <TabSkeleton />
      </>
    )
  }

  return (
    <>
      {plugins?.map(plugin => {
        const app = plugin.provider?.app
        const navigable = canNavigateToApp(plugin)

        const handleClick = () => {
          if (plugin.needs_reauthenticate && navigable) {
            window.location.href = `/apps/${app.id}`
            return
          }
          setActiveTab(plugin.id)
        }

        return (
          <SourceTab
            key={plugin.id}
            icon={
              <img
                src={plugin.icon_url}
                alt={""}
                className="border border-gray-200 p-1 rounded-sm w-8 h-8 object-cover"
              />
            }
            title={plugin.label}
            isPaidFeature={plugin.can_use === false}
            needsReauthenticate={plugin.needs_reauthenticate}
            canNavigate={navigable}
            active={activeTab === plugin.id}
            onClick={handleClick}
          />
        )
      })}
    </>
  )
}
